import React from 'react';
import '../styles/WelcomeSection.css';

const WelcomeSection = ({ isScrolled }) => (
  <div className={`welcome-container ${isScrolled ? 'scrolled' : ''}`}>
    <h2 className="welcome-title">Welcome</h2>
    <div className="welcome-divider"></div>
    <p className="welcome-text">
      Discover your slice of paradise at Turtles Bay resort nestled on the beautiful
      Kadmat Island in Lakshadweep. With white sandy beaches, turquoise lagoons,
      and spectacular sunsets, Turtles Bay offers an intimate escape far from the
      crowds. Whether you seek tranquility or adventure, every moment here is a
      breath of fresh ocean air.
    </p>
  </div>
);

export default WelcomeSection;
